<template>
  <Transition name="fade">
    <ModuleUserOrders v-if="openUserLayer==='orders'"/>
  </Transition>
</template>

<script lang="ts" setup>

import {computed, defineAsyncComponent} from "vue";
import {useStore} from "vuex";


const ModuleUserOrders = defineAsyncComponent(() => import("@km/components/user/ModuleUserOrders.vue"));
const store = useStore();
const openUserLayer = computed(() => store.getters.getOpenUserModules);

</script>

<style scoped lang="scss">
@use "../../scss/settings/mixins.scss" as mixins;

@include mixins.fadeTransition;


</style>
